import { ICenterBase, IWatrRequestCounts } from '@nkr/models/index';
import { FormEvent, useEffect, useState } from 'react';
import { FormControl, Button, Well, ToggleButton, ToggleButtonGroup, ButtonToolbar } from 'react-bootstrap';
import { WageAndTravelStatus, WageAndTravelCategory, WageAndTravelViewType, ReimbursementType, WageAndTravelType, OrganType } from '@nkr/enums/index';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';


interface IProps {
    filterGroup: number[],
    filterCategory: number,
    filterStartDate: string,
    filterEndDate: string,
    isNkrAdmin: boolean,
    counts: IWatrRequestCounts,
    wageTotal: number,
    expensesTotal: number,
    category: WageAndTravelCategory,
    displayedCount?: number,
    totalCount?: number,
    onChaseExport: (organType: OrganType) => void,
    onUpdateCategory: (filterCategory: number) => void,
    onUpdateGroup: (filterGroup: number) => void,
    onUpdateDate: (startDate: string, endDate: string, dateChanged: number) => void,
    onDateSearch: () => void
}

const SubFilterBar = (props: IProps) => {
    const isLessThan1920 = useMediaQuery({
        query: '(width < 1920px)'
    });


    const [startDate, setStartDate] = useState<string>(props.filterStartDate || '');
    const [endDate, setEndDate] = useState<string>(props.filterEndDate || '');

    useEffect(() => {
        setStartDate(props.filterStartDate || '');
        setEndDate(props.filterEndDate || '');
    }, [props.filterStartDate, props.filterEndDate]);


    const handleCategoryChange = (filterCategory: number) => {
        props.onUpdateCategory(filterCategory);
    }

    const handleGroupChange = (filterGroup: any) => {
        props.onUpdateGroup(filterGroup);
    }

    const handleDateRangeSearch = () => {
        props.onDateSearch();
    }

    const handleDateChange = (e: FormEvent<HTMLInputElement & FormControl>) => {
        const { name, value } = e.currentTarget;
        let startDate = '';
        let endDate = '';
        let dateChanged = 0;

        if (name === 'startDate') {
            startDate = value;
            dateChanged = 1;
        } else if (name === 'endDate') {
            endDate = value;
            dateChanged = 2;
        }

        props.onUpdateDate(startDate, endDate, dateChanged);
    };


    let pendingPaymentTotal = props.counts != null ? props.counts.pendingPaymentTotal : 0;
    let pendingVerifyTotal = props.counts != null ? props.counts.pendingVerifyTotal : 0;
    const displayedCount = props.displayedCount != null ? props.displayedCount : 0;
    const totalCount = props.totalCount != null ? props.totalCount : 0;
    const showPendDocsRangeCount = props.category == WageAndTravelCategory.PendDocs;
    const isPartialList = showPendDocsRangeCount && totalCount > displayedCount;


    return (
        <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
            {props.category == WageAndTravelCategory.PendDocs && (<>
                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                    <div>
                        <FormControl
                            type='date'
                            name='startDate'
                            value={props.filterStartDate}
                            onChange={handleDateChange}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
                    <div style={{ marginRight: 5 }}>End Date:</div>
                    <div>
                        <FormControl
                            type='date'
                            name='endDate'
                            value={props.filterEndDate}
                            onChange={handleDateChange}
                        />
                    </div>
                </div>
                <div style={{ marginRight: 12 }}>
                    <Button bsStyle={'primary'} onClick={handleDateRangeSearch}>Search</Button>
                </div>
                {showPendDocsRangeCount && (
                    <div
                        role="status"
                        aria-live="polite"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '6px 10px',
                            borderRadius: 4,
                            background: isPartialList ? '#fff8e6' : '#f5f5f5',
                            border: isPartialList ? '1px solid #f0ad4e' : '1px solid #ddd',
                            color: isPartialList ? '#8a6d3b' : '#555',
                            fontSize: 13,
                            fontWeight: isPartialList ? 600 : 500,
                            lineHeight: 1.3,
                            whiteSpace: 'nowrap',
                        }}
                        title="Count of Pend Reg cases in the selected created-date range versus the full tab total"
                    >
                        {displayedCount.toLocaleString()} of {totalCount.toLocaleString()} in date range
                    </div>
                )}
            </>)}


                {/* {props.category == WageAndTravelCategory.ToDo && (<>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '60px' }} >
                        <div style={{ marginRight: 5 }}>Filters:</div>
                        <ButtonToolbar>
                            <ToggleButtonGroup type='radio' name='options' value={props.filterCategory}>
                                <ToggleButton className='btn-bg' value={WageAndTravelCategory.PendVerify} onClick={() => handleCategoryChange(WageAndTravelCategory.PendVerify)}>
                                    Pending Verify ({pendingVerifyTotal})
                                </ToggleButton>
                                <ToggleButton className='btn-bg' value={WageAndTravelCategory.PendingPayment} onClick={() => handleCategoryChange(WageAndTravelCategory.PendingPayment)}>
                                    Pending ACH ({pendingPaymentTotal})
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </ButtonToolbar>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                        <div style={{ marginRight: 5 }}>Display:</div>
                        <ToggleButtonGroup type='checkbox' value={props.filterGroup} onChange={handleGroupChange}>
                            <ToggleButton value={1}>LWR</ToggleButton>
                            <ToggleButton value={2}>DER</ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                </>)}*/}
            {/*  {props.category == WageAndTravelCategory.ToDo && (<>
                <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '14px' }}>
                    <div style={{ marginRight: '15px', color: '#333' }}>
                        Wage Total: <span style={{ color: '#007bff' }}>${props.wageTotal.toLocaleString()}</span>
                    </div>
                    <div style={{ color: '#333' }}>
                        Expenses Total: <span style={{ color: '#28a745' }}>${props.expensesTotal.toLocaleString()}</span>
                    </div>
                </div>

                <div style={{ display: 'flex', marginRight: '15%' }}>

                    {props.isNkrAdmin && (
                        <Button bsStyle={'primary'} style={{ marginRight: '10px' }} onClick={props.onChaseExport}>
                            Export Chase CSV
                        </Button>
                    )}
                </div>
            </>)}*/}
        </Well>
    );
}

export default SubFilterBar;